import { RpcError } from "grpc-web";
import { AddTimeStampCommentRequest, AddTimeStampCommentResponse, AudioComment, GetTrackTimeStampCommentsRequest, GetTrackTimeStampCommentsResponse } from "../proto/api_pb";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import { backOff } from "exponential-backoff";

export const handleAddCommentOnTrack: (
    userId: string,
    token: string,
    audioComment: AudioComment,
    enterpriseId: string,
    role: number
) => Promise<RpcError | AddTimeStampCommentResponse> = async (
    userId: string,
    token: string,
    audioComment: AudioComment,
    enterpriseId: string,
    role
) => {
        const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
        const request = new AddTimeStampCommentRequest();
        request.setUserId(userId);
        request.setAudioComment(audioComment)
        request.setEnterpriseId(enterpriseId)
        request.setRole(role)
        const metadata = {
            Authorization: token,
            "Access-Control-Allow-Origin": "*",
        };
        return await backOff(
            () =>
                new Promise<AddTimeStampCommentResponse | RpcError>((resolve, reject) => {
                    ommuseClient.addTimeStampComment(
                        request,
                        metadata,
                        function (err, response) {
                            if (err) {
                                reject(err);
                            } else {
                                resolve(response);
                            }
                        }
                    );
                }),
            {
                numOfAttempts: 3,
                jitter: "full",
            }
        );
    };



export const handleGetTrackComments: (
    token: string,
    trackId: string,
    versionId: string
) => Promise<RpcError | GetTrackTimeStampCommentsResponse> = async (
    token: string,
    trackId: string,
    versionId: string
) => {
        const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
        const request = new GetTrackTimeStampCommentsRequest();
        request.setTrackId(trackId)
        request.setVersionId(versionId)
        const metadata = {
            Authorization: token,
            "Access-Control-Allow-Origin": "*",
        };
        return await backOff(
            () =>
                new Promise<GetTrackTimeStampCommentsResponse | RpcError>((resolve, reject) => {
                    ommuseClient.getTrackTimeStampComments(
                        request,
                        metadata,
                        function (err, response) {
                            if (err) {
                                reject(err);
                            } else {
                                resolve(response);
                            }
                        }
                    );
                }),
            {
                numOfAttempts: 3,
                jitter: "full",
            }
        );
    };
